export const XANO_AUTH_GROUP = '9-ms6pAp' as const;
export const XANO_BACKOFFICE_GROUP = 'backoffice' as const;
export const XANO_PRODUCT_GROUP = 'rEsr7KLt' as const;
/** Coleção Salesforce no Xano — job de catálogo em `sf/products`. */
export const XANO_SALESFORCE_GROUP = '_XyGQ1NG' as const;
